import { Pill } from 'ui-components/components/pill';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';

import temuLogo from './temu-logo.svg';
import style from './temu-tags.module.less';
import { TEMU_COLOR } from './temu-constants';

export const TemuMadeToOrderTag = () => {
  return (
    <Pill
      color={TEMU_COLOR}
      label={
        <FlexRow className={style['temu-tag-label']} gap={Gap.Space8}>
          <img alt='' className={style['temu-logo']} src={temuLogo} />
          MTO
        </FlexRow>
      }
      theme='tag'
    />
  );
};
